/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emailsent1Inputs */

const en_emailsent1 = /** @type {(inputs: Emailsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation email sent`)
};

const de_emailsent1 = /** @type {(inputs: Emailsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungs-E-Mail gesendet`)
};

/**
* | output |
* | --- |
* | "Confirmation email sent" |
*
* @param {Emailsent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailsent1 = /** @type {((inputs?: Emailsent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailsent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailsent1(inputs)
	return de_emailsent1(inputs)
});
export { emailsent1 as "emailSent" }